import type { ReactNode } from 'react';

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

import { PostHogProvider } from 'posthog-js/react';

export function PostHog({ children }: { children: ReactNode }) {
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      {children}
    </PostHogProvider>
  );
}
